<template>
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <!-- Page Header -->
        <breadcrumb-header :title="title" :path="path" :text="text" />
        <!-- /Page Header -->

        <div class="row">
          <div class="col-md-12">
            <div class="user-header">
              <h3>{{ userData.name }}&nbsp;({{ companyIdToCompanyRole(userData.company_role_id) }})</h3>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card punch-status">
              <div class="card-body">
                <h5 class="card-title">
                  Timesheet <small class="text-muted">{{ formatDDMMYYYY(new Date()) }}</small>
                </h5>
                <div class="punch-det">
                  <h6>checked In at</h6>
                  <p>{{firstCheckInTime}}</p>
                </div>
                <div class="punch-info">
                  <div class="punch-hours" style="margin: 17% auto;">
                    <span>{{todaysWorkHours}} hrs</span>
                  </div>
                </div>
                <div class="punch-btn-section">
<!--                  <button type="button" class="btn btn-primary punch-btn">-->
<!--                    Punch Out-->
<!--                  </button>-->
                </div>
                <div class="statistics">
                  <div class="row" style="justify-content: center">
                    <div class="col-md-8 col-8 text-center">
                      <div class="stats-box">
                        <p>Break</p>
                        <h6>{{todaysBreakHours}} hrs</h6>
                      </div>
                    </div>
<!--                    <div class="col-md-6 col-6 text-center">-->
<!--                      <div class="stats-box">-->
<!--                        <p>Overtime</p>-->
<!--                        <h6>3 hrs</h6>-->
<!--                      </div>-->
<!--                    </div>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card att-statistics">
              <div class="card-body">
                <h5 class="card-title">Statistics</h5>
                <div class="stats-list">
                  <div class="stats-info">
                    <p>
                      Today <strong>{{todaysWorkHours}} <small>/ {{expectedWorkHoursToday}} hrs</small></strong>
                    </p>
                    <div class="progress">
                      <div
                        class="progress-bar bg-primary"
                        :style="`width:${calcWorkHourPercentage(todaysWorkHours, expectedWorkHoursToday)}%`"
                        role="progressbar"
                        aria-valuenow="48"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                  <div class="stats-info">
                    <p>
                      This Week <strong>{{currentWeekWorkHours}} <small>/ {{currentWeekExpectedWorkHours}} hrs</small></strong>
                    </p>
                    <div class="progress">
                      <div
                        class="progress-bar bg-warning"
                        :style="`width:${calcWorkHourPercentage(currentWeekWorkHours, currentWeekExpectedWorkHours)}%`"
                        role="progressbar"
                        aria-valuenow="90"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                  <div class="stats-info">
                    <p>
                      This Month <strong>{{currentMonthWorkHours}} <small>/ {{currentMonthExpectedWorkHours}} hrs</small></strong>
                    </p>
                    <div class="progress">
                      <div
                        class="progress-bar bg-success"
                        :style="`width:${calcWorkHourPercentage(currentMonthWorkHours, currentMonthExpectedWorkHours)}%`"
                        role="progressbar"
                        aria-valuenow="90"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                  <div class="stats-info">
                    <p>
                      Remaining <strong>{{currentMonthRemainingHours}} <small>/ {{currentMonthExpectedWorkHours}} hrs</small></strong>
                    </p>
                    <div class="progress">
                      <div
                        class="progress-bar bg-danger"
                        :style="`width:${calcWorkHourPercentage(currentMonthRemainingHours, currentMonthExpectedWorkHours)}%`"
                        role="progressbar"
                        aria-valuenow="90"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
<!--                  <div class="stats-info">-->
<!--                    <p>Overtime <strong>4</strong></p>-->
<!--                    <div class="progress">-->
<!--                      <div-->
<!--                        class="progress-bar bg-info w-62"-->
<!--                        role="progressbar"-->
<!--                        aria-valuenow="22"-->
<!--                        aria-valuemin="0"-->
<!--                        aria-valuemax="100"-->
<!--                      ></div>-->
<!--                    </div>-->
<!--                  </div>-->
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card recent-activity">
              <div class="card-body">
                <h5 class="card-title">Today's Activities</h5>
                <ul class="res-activity-list">
                  <li v-for="(activity, index) in todaysActivities" :key="index">
                    <p class="mb-0">{{ activity.type}}</p>
                    <p class="res-activity-time">
                      <i class="fa-regular fa-clock"></i>
                      {{timeFormat(activity.created_at.split(" ")[1])}}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- Search Filter -->
        <attendance-employee-filter @searchClicked="searchClicked"></attendance-employee-filter>
        <!-- /Search Filter -->
        <div class="row">
          <div class="col-lg-12">
            <div class="table-responsive" >
              <table class="table table-striped custom-table table-nowrap mb-0">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Check In</th>
                    <th>Check Out</th>
                    <th>Work Hours</th>
                    <th>Break Taken</th>
                    <th>Edited</th>
                    <th>Reason</th>
                    <th>Updated By</th>
                    <th>Updated At</th>
                   <th  v-if="userInfo.account_type == 'SITE MANAGER' || userInfo.account_type == 'ADMIN'">Action</th>
                  </tr>
                </thead>
                <tbody v-if="attendanceEmployee">
                  <tr v-for="item in attendanceEmployee" :key="item.id">
                    <td>{{ formatDDMMYYYY(item.record_date) }}</td>
                    <td>{{ item.first_check_in_time ? timeFormat(item.first_check_in_time) : '--'}}</td>
                    <td>{{ item.last_check_out_time ? timeFormat(item.last_check_out_time) : '--'}}</td>
                    <td >{{ roundOfInHour(Number(item.total_minutes)-Number(item.break_minutes)) }}</td>
                    <td>{{ roundOfInHour(item.break_minutes) }}</td>
                    <td>{{ item.is_manually_edited ? 'Yes' : 'No' }}</td>
                    <td>{{ item.reason ? item.reason : '--' }}</td>
                    <td>{{ item.updated_by_user ? (item.updated_by_user.first_name + ' ' + item.updated_by_user.last_name) : (item.updated_by && item.updated_by.first_name ? (item.updated_by.first_name + ' ' + item.updated_by.last_name) : (item.updated_by ? item.updated_by : '--')) }}</td>
                    <td>{{ item.is_manually_edited && item.updated_at ? formatDateTimeStandardWithTime(item.updated_at) : '--' }}</td>
                   <td href="javascript:;" data-bs-toggle="modal"
                          data-bs-target="#edit_attendance" @click="editClicked(item)"><i class="fa-solid fa-pen ms-5" v-if="userInfo.account_type == 'SITE MANAGER' || userInfo.account_type == 'ADMIN'"></i></td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="12">
                      <div class="card text-center">
                <div class="card-body">
                  <img src="../../../assets/img/avatar/no-data.png" alt="no-data" srcset="" class="responsive-img">
                  <p>No data have been added.</p>
                </div>
              </div>
                    </td>
              
            </tr>
                </tbody>
              </table>
            </div>
             
          </div>
        </div>
      </div>
      <!-- /Page Content -->
    </div>
    <!-- Page Wrapper -->
     <edit-attendance-modal ref="editAttendance"></edit-attendance-modal>
</template>


<style scoped>
.user-header {
  background-color: #fff;
  padding: 24px;
  border-radius: 10px;
  box-shadow: inset;
  margin-bottom: 30px;
}

.recent-activity .res-activity-list:after {
  content: "";
  border: 1px solid #E9E9EA;
  position: absolute;
  top: 0;
  bottom: -20% !important;
  left: 4px;
}

.responsive-img {
  width: 100%;
  max-width: 100px;
  height: auto;
}
</style>
<script>
// import attendanceEmployee from "@/assets/json/attendance-employee.json";
import axios from "axios";
import {VUE_APP_API_BASE_URL} from "../../../config";
import {formatDDMMYYYY, timeFormat, formatUSDate, formatDateTimeStandardWithTime} from "@/utils/util-funcitons";
import {dateRangeEnd, dateRangeStart} from "@/utils/util-var";
export default {
  data() {
    return {
      attendanceEmployee: null,
      todaysAttendance:null,
      todaysActivities:null,
      firstCheckInTime:null,
      title: "Attendance",
      path: "Dashboard",
      text: "Attendance",
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      startDate:formatUSDate(dateRangeStart),
      endDate:formatUSDate(dateRangeEnd),
      todaysBreakHours:null,
      todaysWorkHours:null,
      currentWeekBreakHours:null,
      currentWeekWorkHours:null,
      currentMonthBreakHours:null,
      currentMonthWorkHours:null,
      expectedWorkHoursToday:null,
      currentWeekExpectedWorkHours:null,
      currentMonthExpectedWorkHours:null,
      currentMonthRemainingHours:null,
      userData:'',
      companyId:[]
    };
  },
  methods:{
    timeFormat,
    formatDDMMYYYY,
    formatDateTimeStandardWithTime,
    getUserName(){
      let instance = this;
      let userInfo = JSON.parse(localStorage.getItem("userInfo"))
      let userId = instance.$route.query.id || userInfo.user_id;
      
      if(userId){
        axios.get(`${VUE_APP_API_BASE_URL}/user/${userId}`)
        .then((response) => {
         
          if (response.data.status) {
            instance.userData = response.data.data;
            instance.userData['name'] = instance.userData["first_name"] + " " + instance.userData["last_name"]
          
          } else {
            instance.errorMessage = response.userData.message ?? "";
          }
        })
        .finally(() => {
          instance.loader = false;
        });
      }
    },
    async getUserAttendance(){
      let instance = this;
       let userInfo = JSON.parse(localStorage.getItem("userInfo"))
        let userId = instance.$route.query.id || userInfo.user_id;

        if(userId){
          await axios.get(`${VUE_APP_API_BASE_URL}/attendance/user/${userId}`,{
        params:{
              start_date:this.startDate,
              end_date:this.endDate,
        }
      }).then((response)=>{
            if(response.data.status){
              instance.attendanceEmployee = response.data.data;

            }
      }).catch(function (error){
        console.log('error ',error);
      });

        }else{ await axios.get(`${VUE_APP_API_BASE_URL}/attendance/user`,{
        params:{
              start_date:this.startDate,
              end_date:this.endDate,
        }
      }).
          then((response)=>{
            if(response.data.status){
              instance.attendanceEmployee = response.data.data;
         
            }
      }).catch(function (error){
        console.log('error ',error);
      });}
         
      
      
    },
    async employeeAttendanceToday(){
      let instance = this;
      let userInfo = JSON.parse(localStorage.getItem("userInfo"))
        let userId = instance.$route.query.id || userInfo.user_id;
      if(userId){
          await axios.get(`${VUE_APP_API_BASE_URL}/attendance/user/${userId}/today`).
      then((response)=>{
        if(response.data.status){
          let responseData = response.data.data;
          instance.todaysAttendance = responseData.todaysAttendance;
          
          if(responseData.todaysAttendance.length > 0){
            instance.firstCheckInTime = formatDDMMYYYY(responseData.todaysAttendance[0].created_at) +' '+ timeFormat(responseData.todaysAttendance[0].created_at.split("T")[1].split(".")[0]);
            instance.todaysActivities = responseData.todaysAttendance[0].user_activities;
          }

          instance.todaysBreakHours=responseData.todaysBreakHours;
          instance.todaysWorkHours=responseData.todaysWorkHours;

          instance.currentWeekBreakHours=responseData.currentWeekBreakHours;
          instance.currentWeekWorkHours=responseData.currentWeekWorkHours;

          instance.currentMonthBreakHours=responseData.currentMonthBreakHours;
          instance.currentMonthWorkHours=responseData.currentMonthWorkHours;

          instance.expectedWorkHoursToday=responseData.expectedWorkHoursToday;
          instance.currentWeekExpectedWorkHours=responseData.currentWeekExpectedWorkHours;
          instance.currentMonthExpectedWorkHours=responseData.currentMonthExpectedWorkHours;

          instance.currentMonthRemainingHours = instance.currentMonthExpectedWorkHours-instance.currentMonthWorkHours;
        }
      }).catch(function (error){
        console.log('error ',error);
      });
      }else{
      await axios.get(`${VUE_APP_API_BASE_URL}/attendance/user/today`).
      then((response)=>{
        if(response.data.status){
          let responseData = response.data.data;
          instance.todaysAttendance = responseData.todaysAttendance;
          if(responseData.todaysAttendance.length > 0){
            instance.firstCheckInTime = formatDDMMYYYY(responseData.todaysAttendance[0].created_at)+' '+timeFormat(responseData.todaysAttendance[0].created_at.split("T")[1].split(".")[0]);
            instance.todaysActivities = responseData.todaysAttendance[0].user_activities;
          }

          instance.todaysBreakHours=responseData.todaysBreakHours;
          instance.todaysWorkHours=responseData.todaysWorkHours;

          instance.currentWeekBreakHours=responseData.currentWeekBreakHours;
          instance.currentWeekWorkHours=responseData.currentWeekWorkHours;

          instance.currentMonthBreakHours=responseData.currentMonthBreakHours;
          instance.currentMonthWorkHours=responseData.currentMonthWorkHours;

          instance.expectedWorkHoursToday=responseData.expectedWorkHoursToday;
          instance.currentWeekExpectedWorkHours=responseData.currentWeekExpectedWorkHours;
          instance.currentMonthExpectedWorkHours=responseData.currentMonthExpectedWorkHours;

          instance.currentMonthRemainingHours = instance.currentMonthExpectedWorkHours-instance.currentMonthWorkHours;
        }
      }).catch(function (error){
        console.log('error ',error);
      });
    }
    },

    editClicked(record) {
      this.$refs.editAttendance.updateValues(record);
    },

    roundOfInHour(time){
      let totalWorkTime = (Math.round(time));
      let hours = Math.floor(totalWorkTime/60);
      let minutes = totalWorkTime%60;
      return `${hours}:${minutes}`;
    },
    searchClicked(data){
      this.startDate=formatUSDate(data.start_date);
      this.endDate=formatUSDate(data.end_date);
      this.getUserAttendance();
    },
    calcWorkHourPercentage(workHours, expectedHours){
       return ((workHours/expectedHours) * 100).toFixed(2);
    },

    companyIdToCompanyRole(id) {
      const company = this.companyId.find(item => item.id === id);
      return company ? company.name : null;
    },

    async getCompanyRoles() {
      await axios.get(`${VUE_APP_API_BASE_URL}/company-role/get`)
        .then((response) => {
          if (response.data.status) {
            this.companyId = response.data.data;
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getUserAttendance();
    this.employeeAttendanceToday();
    this.getCompanyRoles();
    this.getUserName()
  }
};
</script>
